import * as types from './types';

const deletePostingTag = (postingId, tagId) => {
  return {
    type: types.DELETE_POSTING_TAG,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/postings/tags/${postingId}/${tagId}`,
      method: 'DELETE',
      query: { postingId }
    }
  };
};

export { deletePostingTag };
